import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommutator = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.5,
			cy: 8,
			r: 7,
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.4023,
			y: 2.68359,
			width: 2,
			height: 7.44061,
			rx: 1,
			transform: "rotate(45 11.4023 2.68359)",
			fill: "#122138"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.5,
			cy: 8,
			r: 1,
			fill: "#D0D0D0"
		})
	]
});
const ForwardRef = forwardRef(SvgCommutator);
export default ForwardRef;
